import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOut } from "../app/authSlice";
import { useLogoutMutation } from "../app/api/console/consoleAuthApiSlice";
import ConsoleWebsiteSelector from "./ConsoleWebsiteSelector";
import CreateWebsiteModal from "./create_website/CreateWebsiteModal";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logout] = useLogoutMutation();

  const handleLogout = async () => {
    // Clear the server-side httpOnly refresh cookie first, otherwise a later
    // token refresh would silently re-authenticate as this same user.
    try {
      await logout().unwrap();
    } catch (err) {
      // best-effort: still clear local state even if the call fails
    }
    dispatch(logOut());
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <header className='bg-transparent'>
      <div className='h-14 flex items-center justify-between px-6 md:px-8'>
        <ConsoleWebsiteSelector />
        <div className='flex items-center gap-3'>
          <button
            onClick={() => setIsModalOpen(true)}
            className='px-3.5 py-1.5 text-[13px] font-semibold text-white bg-button-primary rounded-xl hover:bg-button-primary-hover transition-colors'>
            + New Website
          </button>
          <button
            onClick={handleLogout}
            className='px-3.5 py-1.5 text-[13px] font-medium text-text-secondary bg-transparent border border-border-default rounded-xl hover:bg-surface-neutral transition-colors'>
            Logout
          </button>
        </div>
        <CreateWebsiteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div>
    </header>
  );
}

export default Header;
